import { baseApiUrl } from '@/global';
import axios from 'axios';

export const omieAlertsMixin = {
  computed: {
    omieAlerts() {
      return this.$store.state.omieAlerts;
    },
  },
  methods: {
    fetchOmieAlerts() {
      const url = `${baseApiUrl}/v1/audits/omie-logs-alerts`;
      return axios(url)
        .then((res) => {
          this.$store.commit('setOmieAlerts', res.data);
        })
        .catch(() => {});
    },
    markOmieLogsSeen(type) {
      const url = `${baseApiUrl}/v1/audits/omie-logs-seen`;
      return axios.post(url, { type }).then((res) => {
        this.$store.commit('setOmieAlerts', res.data);
      });
    },
    formatAlertCount(count) {
      if (!count) return '';
      return count > 99 ? '99+' : String(count);
    },
  },
};
